<template>
  <DiscountCampaignForm :id="id" />
</template>

<script>
import DiscountCampaignForm from './DiscountCampaignForm.vue';

export default {
  name: 'DiscountCampaignEdit',
  components: { DiscountCampaignForm },
  props: {
    id: { type: [String, Number], required: true },
  },
};
</script>
